import React, {useEffect, useState} from 'react';

import {getEtcInfoJson} from "../components/FetchData";
import {_phoneCall} from "../helpers/common";
import "../css/footer.css"

function Footer(props) {

    const [phoneNumber, setPhoneNumber] = useState([]);
    const [accountNumber, setAccountNumber] = useState([]);
    const [accountHolder, setAccountHolder] = useState([]);

    useEffect(()=>{
        setPhoneNumber(getEtcInfoJson().phone);
        setAccountNumber(getEtcInfoJson().account.number);
        setAccountHolder(getEtcInfoJson().account.holder);
    },[])


    return (
        <>
            <div id="footer">
                <hr />
                <div><span>소백산 자연누리 펜션·카라반</span></div>
                <div><span>Address.</span> 경상북도 영주시 풍기읍 삼가로 288</div>
                <div><span>Account.</span> {accountNumber} ({accountHolder})</div>
                <div onClick={(e)=>{_phoneCall(phoneNumber)}}><span>Tel.</span> {phoneNumber}</div>
            </div>
        </>
    );
}

export default Footer;
